/* eslint-disable */
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/Components/ui/popover';

const GroupingDropdown = ({ options, activeKey, onSelect }) => {
	return (
		<div className='relative w-full inline-block'>
			<Popover>
				<PopoverTrigger asChild>
					<button
						className='flex w-full items-center  justify-between px-3 py-1 bg-gray-100 border border-gray-200 rounded-md hover:bg-gray-200 focus:outline-none transition-colors'
					>
						<span className='text-gray-800 text-nowrap font-medium'>
							{options.find((o) => o.key === activeKey)?.label}
						</span>
						<ChevronDown className='h-3 w-3 ml-2 text-gray-500' />
					</button>
				</PopoverTrigger>
				<PopoverContent className="p-0 w-[140px]">
					<div className="bg-white rounded-md shadow-lg py-1">
						{options.map((option) => (
							<div
								key={option.key}
								className={`px-3 py-2 hover:bg-blue-50 cursor-pointer ${
									option.key === activeKey
										? 'bg-blue-50 text-blue-700'
										: 'text-gray-800'
								}`}
								onClick={() => {
									onSelect(option.key);
								}}
							>
								{option.label}
							</div>
						))}
					</div>
				</PopoverContent>
			</Popover>
		</div>
	);
};

export default GroupingDropdown; 